import { ReactNode } from "react";
import "./StatusBadge.css";

interface IStatusBadgeProps {
  variant?: "error" | "success" | "info" | "warning" | "medium";
  size?: "small" | "medium" | "large";
  children: ReactNode;
  className?: string;
}

export const StatusBadge = ({
  variant = "info",
  children,
  className = "",
  size = "medium",
  ...props
}: IStatusBadgeProps) => {
  return (
    <span
      className={`status-badge status-badge--${variant} status-badge-${size} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};
